import React, { useContext, useEffect, useState } from 'react';
import { getAxiosTokenInstance  } from '../../../utils/axiosInstance';
import { NecttosContext } from '../../../context/NecttosContext';

interface CourseViewProps {
  course: any;
  userRole: any;
  selectedModule: any;
  
}

export const MaterialsView: React.FC<CourseViewProps> = ({ course, userRole, selectedModule }) => {
  const [materials, setMaterials] = useState<any[]>([]);
  const { collegeId } = useContext(NecttosContext)

  useEffect(() => {
    // you can fetch materials here if needed
    const loadData = async () => {
      try{
      const instance = await getAxiosTokenInstance();
      const resp = await instance.get(`/college/lms/materials/getAllMaterials`,{
        params: {
       subjectId:course.subjectId,
       collegeId:collegeId
        }
      });
      if (resp?.data) {
        // Check if selectedModule is not 'all'
        console.log(selectedModule)
        if (selectedModule !== 'all') {
          const filteredContent = resp.data.data.filter((content: any) => {
            // Make sure to return true or false based on the condition
            return content.moduleId == selectedModule;
          });
          setMaterials(filteredContent); // Set the filtered content
        } else {
          setMaterials(resp.data.data); // If selectedModule is 'all', show all content
        }
      }
      }catch (err) {
        console.log(err)
      }

    }
    loadData();
  }, [userRole, course, selectedModule]);

  return (
    <div className="p-6 space-y-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <h2 className="text-xl font-semibold">Course Materials</h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* {[
          { name: 'Lecture Notes - Chapter 1', type: 'PDF', size: '2.4 MB', date: '2 days ago', moduleId: 'mod1' },
          { name: 'Video Tutorial - Basics', type: 'Video', size: '45.2 MB', date: '1 week ago', moduleId: 'mod1' },
          { name: 'Linear Equations Examples', type: 'PDF', size: '1.8 MB', date: '3 days ago', moduleId: 'mod2' },
          { name: 'Quadratic Functions Guide', type: 'PDF', size: '3.2 MB', date: '1 day ago', moduleId: 'mod3' }
        ]
          .filter(material => selectedModule === 'all' || material.moduleId === selectedModule) */}
          {materials?.map((material, index) => (
            <div key={index} className="bg-white dark:bg-gray-800 rounded-lg shadow p-4 hover:shadow-md transition-shadow cursor-pointer border border-gray-200 dark:border-gray-700">
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <h3 className="font-medium">{material.title}</h3>
                  <p className="text-sm text-gray-500">{material?.description}</p>
                  {/* <p className="text-sm text-gray-500">{material?.file.fileType} • {material?.file.fileSize}</p> */}
                  <p className="text-xs text-gray-400 mt-1">{material?.fileName}</p>
                </div>
                <button className="inline-flex items-center px-3 py-1 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100">
                  Download
                </button>
              </div>
            </div>
          ))}

      </div>
      {materials.length === 0 && (
        <div className="text-center py-12">
          <span className="text-6xl mb-4 block">-</span>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            No materials found
          </h3>
          <p className="text-gray-500">
            No materials available for the selected module.
          </p>
        </div>
      )}
    </div>
  );
};
